import { API_KEY } from "../env";

export const getHeaders = () => {
    let headers = {
        'Content-Type': 'application/json',
        'ApiKey': API_KEY,
        'Pragma': 'no-cache'
    }

    return headers;
}